import { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";


import chat from './../media/icons/chat.png'
import file from './../media/icons/file.png'
import git from './../media/icons/git.png'
import { Vortex } from "../components/vortex";
import { images } from "../utilities/img";
import { icons } from "../utilities/icn";
import { setgtMessage } from "../redux/gtmsgSlice";
import { gtNeutral } from "../redux/gtstatusSlice";



const PrivacyPolicy = () => {

    const dispatch = useDispatch()

    const [windowWidth, setWindowWidth] = useState(window.innerWidth)


    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleStoreMessage = () => {
        dispatch(setgtMessage('Verification Processing'))
        dispatch(gtNeutral())
    }



    return ( 
        <div className="">

            <section id="home" className="home">
                
                {/* <div className="home-frame"> */}

                    <div className="home-account-management">

                        <div className="mgb-30">
                            <h1 className="inter mgb-20">Privacy Policy for ROSA</h1>
                            <h3 className="inter mgb-20">
                                Effective Date: 12th May, 2025<br /><br />
                                ROSA is committed to protecting your privacy. This Privacy Policy describes how we collect, use, and share information 
                                when you use our mobile application and related services ("ROSA App and ROSA Web site").
                            </h3>

                            <h2 className="inter mgb-20">1. Information We Collect</h2>
                            <h4 className="inter"><b>a. Personal Information You Provide</b></h4>
                            <div className="grid grid-column-1 gap-20 mgb-20 home-am-left-pad">
                                <h4 className="inter">1. Email address or authentication details if you create an account.</h4>
                                <h4 className="inter">2. Any information you submit through website features (e.g., mood logs, check-ins).</h4>
                            </div>

                            <h4 className="inter"><b>b. Health and Fitness Data</b></h4>
                            <div className="grid grid-column-1 gap-20 mgb-20 home-am-left-pad">
                                <h4 className="inter">1. Steps walked, distance cycled or run, calories burned.</h4>
                                <h4 className="inter">2. Heart rate and sleep data (collected via ROSA Ring or device sensors).</h4>
                                <h4 className="inter">3. Mood check-ins and wellness-related inputs.</h4>
                            </div>

                            <h4 className="inter"><b>c. Automatically Collected Data</b></h4>
                            <div className="grid grid-column-1 gap-20 mgb-20 home-am-left-pad">
                                <h4 className="inter">1. Location data (only when required and with permission).</h4>
                            </div>

                            <h2 className="inter mgb-20">2. How We Use Your Information</h2>
                            <h4 className="inter">We use your information to:</h4>
                            <div className="grid grid-column-1 gap-20 mgb-20 home-am-left-pad">
                                <h4 className="inter">1. Provide and improve the core features of the ROSA app.</h4>
                                <h4 className="inter">2. Analyze wellness trends and generate personalized insights.</h4>
                                <h4 className="inter">3. Enable optional features like premium content access.</h4>
                                <h4 className="inter">4. Ensure app stability and enhance performance.</h4>
                            </div>

                            <h2 className="inter mgb-20">3. Data Sharing and Third-Party Services</h2>
                            <h4 className="inter">
                                We do not sell your personal data.<br /><br />
                                We may share certain information:
                            </h4>
                            <div className="grid grid-column-1 gap-20 mgb-20 home-am-left-pad">
                                <h4 className="inter">1. With Firebase (for authentication and backend services).</h4>
                                <h4 className="inter">2. As required by law or to protect rights and safety.</h4>
                            </div>

                            <h2 className="inter mgb-20">4. Retention Policy</h2>
                            <h4 className="inter mgb-20">
                                We retain your data for as long as your account is active or as needed to provide you services. You can request deletion of your data at any time by visiting:
                                ➡️ <a href="https://neurosa.ai/profile">https://neurosa.ai/profile</a> → Tap on Data Management to manage or delete your account and associated data.
                            </h4>

                            <h2 className="inter mgb-20">5. Your Rights</h2>
                            <h4 className="inter mgb-10">You have the right to:</h4>
                            <div className="grid grid-column-1 gap-20 mgb-10 home-am-left-pad">
                                <h4 className="inter">1. Request deletion.</h4>
                                <h4 className="inter">2. Withdraw consent or delete your account entirely.</h4>
                            </div>
                            <h4 className="inter mgb-20">To exercise these rights, use the website Data Management tool at <a href="https://neurosa.ai/profile">https://neurosa.ai/profile</a> </h4>

                            <h2 className="inter mgb-20">6. Children’s Privacy</h2>
                            <h4 className="inter mgb-20">The ROSA app is not intended for children under the age of 13. We do not knowingly collect data from children.</h4>

                            <h2 className="inter mgb-20">7. Changes to This Policy</h2>
                            <h4 className="inter mgb-20">We may update this Privacy Policy from time to time. We’ll notify users of significant changes via app updates or notifications.</h4>

                            <h2 className="inter mgb-20">8. Contact Us</h2>
                            <h4 className="inter mgb-20">For questions or concerns about your privacy, contact us at: proj.rosa2025@gmail.com</h4>


                            
                        </div>

                    </div>

                {/* </div> */}


            </section>

        </div>
    );
}
 
export default PrivacyPolicy;